
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisWithCountModule } from '@go-modules/components/ellipsis-with-count/ellipsis-with-count.module';
import { SessionTableComponent } from '@go-modules/components/activity-view/session-table/session-table.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { SessionMenuModule } from '../session-menu/session-menu.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { ThumbnailModule } from '@go-modules/components/thumbnail/thumbnail.module';
import { LoadingModule } from '@go-modules/components/loading/loading.module';
import { VideoShareDialogModule } from '@go-modules/components/dialogs/video-share-dialog/video-share-dialog.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		EllipsisWithCountModule,
		FormatTimeModule,
		DotIndicatorModule,
		SessionMenuModule,
		MenuModule,
		ThumbnailModule,
		LoadingModule,
		VideoShareDialogModule
	],
	declarations: [
		SessionTableComponent
	],
	exports: [
		SessionTableComponent
	]
})
export class SessionTableModule {}
